import axios from "axios"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../utils/storage"

export const requestUpgradeApi = async (params) => {
  let url = `companies/${LOCAL_COMPANY_ID()}/request-upgrade`
  let method = "POST"
  let token = LOCAL_TOKEN()
  try {
    var request = await axios.request({
      method,
      headers: { Authorization: `Bearer ${token}` },
      data: params,
      url: `${process.env.API_URL + url}`,
    })
    returnMessage(request)
  } catch (error) {
    returnMessage(error)
  }
}
